<template>
  <div class="faq-page">
    <div v-if="Object.keys(menuDetail).length" class="faq-content">
      <div class="breadcrumb">
        <span>{{ menuDetail.parent ? menuDetail.parent.name : '' }}</span>
        <span class="mx-5">&gt;</span>
        <span class="breadcrumb-current">{{ menuDetail.name }}</span>
      </div>
      <van-tabs v-if="classList.length" v-model="categoryIdThird" @click="onActiveClass">
        <van-tab v-for="item in classList" :key="item.id" :title="item.name" :name="item.id"></van-tab>
      </van-tabs>
      <div class="faq-list">
        <div
          v-for="item in faqList"
          :key="item.id"
          class="faq-item"
          @click="handleJump(item.id)"
        >
          {{ item.title }}
        </div>
      </div>
      <div class="pagination-wrap" v-if="page.total > page.pageSize">
        <van-pagination
          v-model="page.pageNo"
          :page-count="pageCount"
          mode="simple"
          @change="handlePageChange"
        />
      </div>
    </div>
    <div v-else-if="!loading" class="empty">
      <van-empty description="暂无数据" />
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      faqList: [],
      menuDetail: {},
      classList: [],
      categoryIdThird: '',
      loading: false,
      page: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
      },
    }
  },
  computed: {
    pageCount() {
      return Math.ceil(this.page.total / this.page.pageSize) || 1
    },
  },
  watch: {
    '$route.params.id'() {
      this.page.pageNo = 1
      this.categoryIdThird = ''
      this.faqList = []
      this.menuDetail = {}
      this.classList = []
      this.init()
    },
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      this.getFaqList()
      this.getFaqDetail()
    },
    getFaqList() {
      this.loading = true
      this.$apis.gameProblemServer.queryPage({
        pageNo: this.page.pageNo,
        pageSize: this.page.pageSize,
        categoryId: '',
        categoryIdSecond: this.$route.params.id,
        categoryIdThird: this.categoryIdThird,
      }).then(res => {
        if (res.code === 0) {
          this.faqList = res.data.dataList
          this.page.total = res.data.totalNum
        }
        this.loading = false
      }).catch(() => { this.loading = false })
    },
    getFaqDetail() {
      this.$apis.gameProblemServer.categoryDetail({
        id: this.$route.params.id,
      }).then(res => {
        if (res.code === 0) {
          this.menuDetail = res.data
          if (res.data.child && res.data.child.length) {
            this.classList = [{ id: '', name: '全部' }, ...res.data.child]
          } else {
            this.classList = []
          }
        }
      })
    },
    onActiveClass(id) {
      this.page.pageNo = 1
      this.categoryIdThird = id
      this.getFaqList()
    },
    handlePageChange() {
      this.getFaqList()
    },
    handleJump(id) {
      this.$router.push({ path: '/commonGameProblem/faqInfo', query: { id } })
    },
  },
}
</script>
<style lang="scss" scoped>
.faq-page {
  background: #f5f7fb;
  min-height: 100%;
}
.faq-content {
  background: #fff;
  margin: 24px;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 2px 12px rgba(0,0,0,0.06);
}
.breadcrumb {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  padding: 24px 32px;
  font-size: 26px;
  color: #999;
  background: #fafbff;
  .breadcrumb-current {
    color: #5a88ff;
    font-weight: 600;
  }
  .mx-5 {
    margin: 0 10px;
    display: inline-flex;
    align-items: center;
  }
}
.faq-list {
  padding: 0 32px;
}
.faq-item {
  padding: 30px 0;
  font-size: 28px;
  color: #333;
  border-bottom: 1px solid #f0f2f5;
  line-height: 1.5;
  transition: color 0.2s;
  position: relative;
  &:active {
    color: #5A88FF;
  }
  &::after {
    content: '›';
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
    font-size: 36px;
    color: #ccc;
    font-weight: 300;
  }
  &:last-child {
    border-bottom: none;
  }
}
.pagination-wrap {
  padding: 24px 32px 32px;
  display: flex;
  justify-content: center;
}
.empty {
  padding-top: 160px;
}
/deep/ .van-tabs__wrap {
  padding: 0 16px;
  .van-tab {
    font-size: 28px;
    line-height: 56px;
  }
  .van-tabs__line {
    background: #5A88FF;
  }
}
/deep/ .van-pagination {
  font-size: 26px;
  .van-pagination__item {
    min-width: 56px;
    height: 56px;
  }
  .van-pagination__item--active {
    background: #5A88FF;
    border-color: #5A88FF;
  }
}
</style>
